import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { User } from 'APP/store/Users/User/User';

import { IEventCalendar, IUpdateEvent } from '../../Content.types';
import { Form } from '../Form/Form';
import { ICalendarEventSubmitData } from '../Form/Form.types';

interface IEditProps {
  selectedEvent: IEventCalendar;
  participantsInfo: User[];
  updateSelectedEvent: (params: IUpdateEvent) => void;
  jumpTo: (date: Date) => void;
  onEdit: (params: ICalendarEventSubmitData) => Promise<void>;
  isFormMinimized?: boolean | undefined;
  onClose?: () => void;
  minimizeSideBar?: () => void;
}

export const Edit: FC<IEditProps> = observer((props) => {
  const {
    onEdit,
    selectedEvent,
    updateSelectedEvent,
    jumpTo,
    participantsInfo,
    isFormMinimized,
    onClose,
    minimizeSideBar,
  } = props;

  return (
    <Form
      event={selectedEvent}
      updateEvent={updateSelectedEvent}
      jumpTo={jumpTo}
      handleSubmit={onEdit}
      participantsInfo={participantsInfo}
      isFormMinimized={isFormMinimized}
      onClose={onClose}
      minimizeSideBar={minimizeSideBar}
    />
  );
});
